<div>
    <dl-card [areaId]="device.hardwareItem.areaId"
          [hardwareItemId]="device.hardwareItem.id"
          [locationId]="device.locationId"
          [currentControl]="device.controls"
          [device]="device"
    ></dl-card>
</div>
